import { EWinPresentationStates } from '@Core/Win/States/WinPresentationStates';
import { IWinPresentation } from '@GameStore/GameStoreSchema';
import { EWinType } from '@Managers/Redux/HttpState';

export const WIN_PRESENTATION_DEFAULTS: IWinPresentation = {
    isSkipped: false,
    isTerminated: false,
    currentSublevelName: EWinType.NORMAL_WIN,
    currentState: EWinPresentationStates.WIN_PRESENTATION_HIDDEN_STATE,
    bet: 0,
    totalWin: 0,
    finalSublevelName: '',
    currentSublevelIndex: 0,
    finalSublevelIndex: 0
};
